import MonteCarloSimulation from'./MonteCarloSimulation';export default MonteCarloSimulation;